import { InitialValues } from 'forms/types';
import { BenefitPeriodLength } from 'types/graph';

import { BenefitPeriodFormValues } from '../form/types';
import { GetBenefitPeriodQuery } from '../graphql/GetBenefitPeriod';

const buildInitialValues = (
  data?: GetBenefitPeriodQuery
): InitialValues<BenefitPeriodFormValues> => ({
  benefitPeriod: data?.surveyBenefitPeriod.benefitPeriod ?? BenefitPeriodLength.ToAge_65,
});

export default buildInitialValues;
